import { combineReducers } from 'redux';
import { generators } from './generators';

export const store = combineReducers({
  handleOauthRedirect: generators.handleOauthRedirect.store(),
  unlinkOauth: generators.unlink.store(),
});
